// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_o6-0";
export var animationContainer = "_o6-1";
export var itemPrice = "_o6-a";
export var itemizedContent = "_o6-9";
export var itemizedHeader = "_o6-7";
export var itemizedRow = "_o6-8";
export var itemizedSection = "_o6-6";
export var modalContent = "_o6-2";
export var orderName = "_o6-3";
export var refundOption = "_o6-4";
export var refundOptionsContainer = "_o6-5";
export var shippingLabel = "_o6-b";
export var totalRow = "_o6-c";